module.exports = __webpack_public_path__ + "static/banner.25a3587f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/banner.png
// module id = 1037
// module chunks = 2